/*
 * 用户相关 API
 */
import httpRequest from "./http";

const userApi = {
  // 刷新 token
  refreshToken: function (params) {
    return httpRequest("post", "/auth/refresh", params);
  },

  // 获取 token 过期时间（TTL）
  getTokenTtl: function () {
    return httpRequest("post", "/auth/ttl", {}, false);
  },
};

export default userApi;
